import { Component, OnInit, AfterViewInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FundrecommService } from 'src/app/services/fundrecomm.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import 'dotdotdot-js'
@Component({
  selector: 'app-fundrecomm',
  templateUrl: './fundrecomm.component.html',
  styleUrls: ['./fundrecomm.component.scss']
})
export class FundrecommComponent implements OnInit, AfterViewInit {
  language = JSON.parse(localStorage.getItem('language'))
  @ViewChildren('dot') dot: QueryList<ElementRef>
  private navigateTo: any
  choiceFromSelect: string
  pageTitle: string

  flag: any

  valueDropdown = [
    {
      id: 1,
      value: this.language.fundrecommmenutab1
    },
    {
      id: 2,
      value: this.language.fundrecommmenutab2
    },
    {
      id: 3,
      value: this.language.fundrecommmenutab3
    },
    {
      id: 4,
      value: this.language.fundrecommmenutab4
    }
  ];

  highlightFundRecommend: any

  fundrecomm: any
  totalfundrecommPage: any
  renderfundrecomm: any

  market: any
  totalmarketPage: any
  rendermerket: any

  date_tmp: any
  date_week: any;
  date_tmp2: any

  fundrecommDate: any

  fundrecommCurrentPage: number = 1;
  marketCurrentPage: number = 1;

  check_month = false;
  date_now = new Date();

  constructor(private route: ActivatedRoute, private _fundrecommService: FundrecommService, private _sanitizer: DomSanitizer) { }

  getMonday(d) {
    d = new Date(d);
    var day = d.getDay(),
      diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    return new Date(d.setDate(diff));
  }

  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  ngOnInit() {

    this.flag = localStorage.getItem("language_flag")

    const xxxx = this.getMonday(new Date());
    this.date_tmp2 = this.addDays(xxxx, 4);

    const d = new Date();
    const month_week = d.getMonth();
    const month_tmp = this.date_tmp2.getMonth();
    const end_of_month = new Date(d.getFullYear(), month_week + 1, 0);
    const first_day = new Date(d.getFullYear(), month_week, 1);
    if (month_week !== month_tmp) {
      this.check_month = true;
      this.date_week = this.getMonday(new Date()).getDate();
      this.date_tmp = this.date_tmp2.getDate();
    } else {
      this.date_tmp = first_day.getDate() + '-' + end_of_month.getDate();
      // this.date_tmp = this.getMonday(new Date()).getDate() + '-' + this.date_tmp2.getDate();
    }

    this.navigateTo = this.route.params.subscribe(params => {
      if (params['type'] === 'option4') {
        this.choiceFromSelect = params['type']
        this.pageTitle = this.language.fundrecommmenutab4;
        this._fundrecommService.get_fundRecomList_top3().subscribe(response => {
          this.highlightFundRecommend = response;
        })
        this._fundrecommService.get_fundRecomList().subscribe(response => {
          this.fundrecomm = response;
          this.totalfundrecommPage = this.setTotalpromotionPage(this.fundrecomm);
          this.setRenderpromotionPerpage(this.fundrecomm);
        })

      } else if (params['type'] === 'option1') {
        this.choiceFromSelect = params['type']
        this.pageTitle = this.language.fundrecommmenutab1;
        this._fundrecommService.get_marketList_top3().subscribe(response => {
          this.market = response;
          this.totalmarketPage = this.setTotalpromotionPage(this.market);
          this.setRenderMarketPerpage(this.market);
        })
      } else if (params['type'] === 'option2') {
        this.choiceFromSelect = params['type']
        this.pageTitle = this.language.fundrecommmenutab2;
        this._fundrecommService.get_newsletterList_top3().subscribe(response => {
          this.highlightFundRecommend = response;
        })
        this._fundrecommService.getnewsletter_listNotTop3().subscribe(response => {

          this.fundrecomm = response;
          this.totalfundrecommPage = this.setTotalpromotionPage(this.fundrecomm);
          this.setRenderpromotionPerpage(this.fundrecomm);
        })

      } else if (params['type'] === 'option3') {
        this.choiceFromSelect = params['type']
        this.pageTitle = this.language.fundrecommmenutab3;

        this._fundrecommService.get_vdoList_top3().subscribe(response => {
          this.highlightFundRecommend = response;
        })
        this._fundrecommService.getvdo_list_notTop3().subscribe(response => {
          this.fundrecomm = response;
          this.totalfundrecommPage = this.setTotalpromotionPage(this.fundrecomm);
          this.setRenderpromotionPerpage(this.fundrecomm);
        })
      }

    })
  }

  ngAfterViewInit() {
    this.dot.changes.subscribe(() => {
      this.dot.toArray().forEach(el => {
        $(el.nativeElement).dotdotdot({
          truncate: 'letter',
          watch: true,

        })
      })
    })
  }

  getBackground(image) {
    return this._sanitizer.bypassSecurityTrustStyle(`url(${image})`);
  }

  setTotalpromotionPage(newsList) {
    if (newsList.length <= 6) {
      return 1;
    } else {
      return Math.ceil(newsList.length / 6);
    }
  }

  setRenderpromotionPerpage(newsList) {
    if (newsList === undefined) {
      return null;
    } else {

      this.renderfundrecomm = newsList.slice(this.fundrecommCurrentPage * 6 - 6, this.fundrecommCurrentPage * 6);
    }
  }

  setRenderMarketPerpage(newsList) {
    if (newsList === undefined) {
      return null;
    } else {

      this.rendermerket = newsList.slice(this.marketCurrentPage * 6 - 6, this.marketCurrentPage * 6);
    }
  }

  changeFormatDate(date) {
    if (date === '') {
      return null;
    } else {
      return this.fundrecommDate = this._fundrecommService.changeFormatDate(date);
    }
  }

  changeFormatDate_getdate(date) {
    if (date === '') {
      return null;
    } else {
      return this.fundrecommDate = this._fundrecommService.changeFormatDate_getdate(date);
    }
  }

  changeFormatDate_getMMyyyy(date) {
    if (date === '') {
      return null;
    } else {
      return this.fundrecommDate = this._fundrecommService.changeFormatDate_getMMyyyy(date);
    }
  }
  changeFormatDate_getDateEnd(date) {
    if (date === '') {
      return null;
    } else {
      return this.fundrecommDate = this._fundrecommService.changeFormatDate_getDateEnd(date);
    }
  }

  setCurrentfundrecommPage(event) {
    this.fundrecommCurrentPage = event;
    this.setRenderpromotionPerpage(this.fundrecomm);
  }

  setCurrentmarketPage(event) {
    this.marketCurrentPage = event;
    this.setRenderMarketPerpage(this.market);
  }

  selectValue(event) {
    if (event == 1) {
      this.choiceFromSelect = 'option1'
      this._fundrecommService.get_marketList_top3().subscribe(response => {

        this.market = response;
        this.totalmarketPage = this.setTotalpromotionPage(this.market);
        this.setRenderMarketPerpage(this.market);
      })
    } else if (event == 2) {
      this.choiceFromSelect = 'option2'
      this._fundrecommService.get_newsletterList_top3().subscribe(response => {

        this.highlightFundRecommend = response;
      })
      this._fundrecommService.getnewsletter_listNotTop3().subscribe(response => {

        this.fundrecomm = response;
        this.totalfundrecommPage = this.setTotalpromotionPage(this.fundrecomm);
        this.setRenderpromotionPerpage(this.fundrecomm);
      })
    }
    else if (event == 3) {
      this.choiceFromSelect = 'option3'
      this._fundrecommService.get_vdoList_top3().subscribe(response => {
        this.highlightFundRecommend = response;
      })
      this._fundrecommService.getvdo_list_notTop3().subscribe(response => {
        this.fundrecomm = response;
        this.totalfundrecommPage = this.setTotalpromotionPage(this.fundrecomm);
        this.setRenderpromotionPerpage(this.fundrecomm);
      })
    }
    else if (event == 4) {
      this.choiceFromSelect = 'option4'
      this._fundrecommService.get_fundRecomList_top3().subscribe(response => {
        this.highlightFundRecommend = response;
      })
      this._fundrecommService.get_fundRecomList().subscribe(response => {

        this.fundrecomm = response;
        this.totalfundrecommPage = this.setTotalpromotionPage(this.fundrecomm);
        this.setRenderpromotionPerpage(this.fundrecomm);
      })
    }
  }


}
